module.exports = __webpack_public_path__ + "img/aiIcon-plantDetect.49304ab8.svg";